import React from 'react';
import PropTypes from 'prop-types';

// ui
import { makeStyles } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import Grid from '@material-ui/core/Grid';
import { Typography } from '@material-ui/core';

import { useTranslation } from 'react-i18next';

// style, icons
import { styles } from './style';
import DamLargeColor from '../../../components/color/dam/DamLargeColor';
import {
  Dam1Icon,
  Dam2Icon,
  Dam3Icon,
  Dam4Icon,
  Dam5Icon,
} from '../../../assets/svg/Icon';

const useStyles = makeStyles(styles);

export default function DamUseWater(props) {
  const { t } = useTranslation();
  const classes = useStyles();
  const { data } = props;

  function getStatus(d) {
    let statusImg = <Dam1Icon style={{ fontSize: '6rem' }} />;
    const currentStatus = DamLargeColor(d);
    const color = currentStatus.color.statusColor;

    if (typeof (d) === 'undefined') {
      return statusImg;
    }

    if (d > 100) {
      statusImg = <Dam5Icon style={{ fontSize: '6rem' }} />;
    } else if (d > 80) {
      statusImg = <Dam4Icon style={{ fontSize: '6rem' }} />;
    } else if (d > 50) {
      statusImg = <Dam3Icon style={{ fontSize: '6rem' }} />;
    } else if (d > 30) {
      statusImg = <Dam2Icon style={{ fontSize: '6rem' }} />;
    } else if (d <= 30) {
      statusImg = <Dam1Icon style={{ fontSize: '6rem' }} />;
    }

    return [statusImg, color];
  }

  // get dam color
  const status = getStatus(data.dam_uses_water_percent);

  return (
    <>
      <Box className={classes.boxContent} p={1}>
        <Box p={0} display="flex" justifyContent="center" alignItems="center" height="85px">
          <Box p={0}>
            {status[0]}
          </Box>
          <Box p={0} className={`${classes.valuePer}`} style={{ color: status[1] }} id="dam_uses_water_percent">
            {`${data.dam_uses_water_percent}%`}
          </Box>
        </Box>
        <Grid container direction="column" justifycontent="center" alignItems="center">
          <Typography className={classes.lable}>
            {t('น้ำใช้การ')}
          </Typography>
          <Typography className={`${classes.value} ${classes.one}`} style={{ color: status[1] }}>
            {/* {data.dam_uses_water.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')} */}
          </Typography>
          <Typography className={classes.unit}>
            {t('ล้านลูกบาศก์เมตร')}
          </Typography>
          <Typography className={classes.dateTime}>
            {`${t('ล่าสุด')} : ${data.dam_start_date} (${t('รวมแหล่งน้ำขนาดใหญ่และขนาดกลาง')})`}
          </Typography>
        </Grid>
      </Box>
    </>
  );
}

DamUseWater.propTypes = {
  data: PropTypes.instanceOf(Object).isRequired,
};
